import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../components/Layout';
import ErrorView from '../views/404';

const ErrorPage = props => {
  const {
    pageContext: { locale },
    location: { pathname },
  } = props;

  return (
    <Layout locale={locale} localeDir={pathname}>
      <ErrorView />
    </Layout>
  );
};

ErrorPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default ErrorPage;
